import { render, staticRenderFns } from "./VNumber.vue?vue&type=template&id=484b7acc&scoped=true&"
import script from "./VNumber.vue?vue&type=script&lang=js&"
export * from "./VNumber.vue?vue&type=script&lang=js&"
import style0 from "./VNumber.vue?vue&type=style&index=0&id=484b7acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484b7acc",
  null
  
)

export default component.exports